<script setup>
import {onMounted, reactive, ref, watch} from "vue";

const props = defineProps({
    content: {
        type: Object,
        required: true,
    },
});

</script>
<template>
    <div v-if="content.uuid">
        <external-widget
            :widget-uuid="content.uuid"
        />
    </div>
</template>
